"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectAuthEmailDefinition = exports.authEmailDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.authEmailDefinition = (0, firestore_1.defineCollection)({
    collectionName: "authEmail",
    idKey: "email",
    constraints: ["email"],
    keysToSave: ["email"],
    queryDefs: {
        list: ({ createdAt, condition, }) => {
            return {
                queryParams: {
                    filter: { createdAt },
                    orderBy: [["createdAt", "desc"]],
                },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({ createdAt: Date.now() }, o), { updatedAt: Date.now() })),
});
exports.projectAuthEmailDefinition = (0, firestore_1.defineCollection)({
    collectionName: "authEmail",
    idKey: "email",
    constraints: ["projectId"],
    keysToSave: ["email"],
    parent: project_1.projectDefinition,
    queryDefs: {
        list: ({ projectId, condition, }) => {
            return {
                constraint: { projectId },
                queryParams: {},
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({ createdAt: Date.now() }, o), { updatedAt: Date.now() })),
});
